<div class="eye-link-container">
  @if (dataContext) {
    <a [href]="dataContext" target="_blank" rel="noopener noreferrer" (click)="onLinkClick($event)">
      <img src="assets/icons/eye.svg" alt="View Details" [title]="dataContext" />
    </a>
  }
</div>
